module.exports = __webpack_public_path__ + "img/banner3.030c096c.png";